import { Select, Textarea } from '@mantine/core'
import { DatePickerInput } from '@mantine/dates'
import { UseFormReturnType } from '@mantine/form'

import { Icons } from 'src/common/components/ui'

import { MutateEscalationData } from '../../escalation.types'
import styles from './escalation-form-fields.module.scss'

const TROUBLESHOOT_DURATION_OPTIONS = ['1-5 mins', '5-10 mins', '10+ mins']

interface Props {
  updateEscalationForm: UseFormReturnType<MutateEscalationData>
  readOnly: boolean
}

const EscalationFormFields = ({ updateEscalationForm, readOnly }: Props) => {
  return (
    <>
      <Textarea
        label="Provide a detailed summary of the driver’s issue and desired resolution below"
        classNames={{
          label: styles.label,
          input: styles.input,
        }}
        {...updateEscalationForm.getInputProps('formFields.summary')}
        readOnly={readOnly}
      />
      <DatePickerInput
        placeholder="MM/DD/YYYY"
        valueFormat="MM/DD/YYYY"
        label="When did this issue start?"
        required
        maxDate={new Date()}
        rightSection={<Icons.Calendar className={styles['calender-icon']} />}
        highlightToday={true}
        popoverProps={{
          offset: 0,
          width: 'target',
          withinPortal: false,
          transitionProps: { transition: 'scale-y', duration: 300 },
          middlewares: {
            flip: false,
            shift: false,
            inline: true,
          },
        }}
        classNames={{
          label: styles.label,
          input: styles.input,
        }}
        {...updateEscalationForm.getInputProps('formFields.startDate')}
        defaultDate={new Date(2015, 1)}
        readOnly={readOnly}
      />
      <Textarea
        label="How did you attempt to troubleshoot the driver’s issue on the call?"
        classNames={{
          label: styles.label,
          input: styles.input,
        }}
        {...updateEscalationForm.getInputProps('formFields.troubleshooting')}
        readOnly={readOnly}
      />
      <Select
        label="If a conference call was needed, how long did it take?"
        classNames={{
          label: styles.label,
          input: styles.input,
        }}
        data={TROUBLESHOOT_DURATION_OPTIONS}
        comboboxProps={{ position: 'bottom' }}
        {...updateEscalationForm.getInputProps('formFields.callDuration')}
        readOnly={readOnly}
      />
    </>
  )
}
export default EscalationFormFields
